import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async saveUpdateMeta({ commit }, data) {
      try {
        return await api.post(
          `/centros-custos/${data.codCCustoPai}/orcamento/${data.orcamentoId}/metas`,
          data.meta,
        )
      } catch (error) {
        throw error
      }
    },

    async getMetas({ commit }, filters) {
      try {
        const response = await api.get(
          `/centros-custos/${filters.codCCustoPai}/orcamento/${filters.orcamentoId}/metas?periodoOrcamento=${filters.periodoOrcamento}`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
